import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { apiClient } from "../api/apiClient";
import { ArrowLeft, Check } from "lucide-react";

export default function SuccessPage() {
  const { job_id: jobId } = useParams();
  const navigate = useNavigate();

  // Phase: idle | transferring | done
  const [phase, setPhase] = useState("idle");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleTransfer = async () => {
    if (!jobId) return;

    setPhase("transferring");
    setError("");
    setMessage("");

    try {
      await new Promise((resolve) => setTimeout(resolve, 500));

      const res = await apiClient.post(`/execute-migration/${jobId}`);
      const status = res.status || "started";
      const msg = res.message || res.msg || "Migration started.";

      setMessage(msg);

      if (status === "started" || status === "already_processing") {
        setPhase("transferring");
        setTimeout(() => setPhase("done"), 4000);
      } else {
        setPhase("done");
      }
    } catch (err) {
      const msg =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        err.message ||
        "Migration execution failed.";
      setError(msg);
      setPhase("idle");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg px-4">
      <div className="w-full max-w-md text-center">

        <div className="relative bg-white border border-border rounded-2xl p-8 shadow-xl">

          {/* Top Left Button */}
          <button
            onClick={() => navigate("/migration/jobs")}
            className="absolute top-4 left-4 text-xs text-text-muted hover:text-text-secondary transition"
          >
            View All Jobs
          </button>

          {/* Top Right Button */}
          <button
            onClick={() => navigate(`/migration/job/${jobId}`)}
            className="absolute top-4 right-4 text-xs text-text-muted hover:text-text-secondary transition"
          >
            Job Status
          </button>

          {/* Success Icon */}
          <div className="flex items-center justify-center mb-4 mt-4">
            <div className="w-12 h-12 rounded-full border-2 border-green-500 flex items-center justify-center">
              <Check className="text-green-500" size={22} />
            </div>
          </div>

          <h2 className="text-2xl font-semibold text-text-primary mb-2">
            Payment Successful!
          </h2>

          <p className="text-sm text-text-secondary mb-6">
            Your transaction has been completed and your account is now ready to proceed.
          </p>

          {/* Status Messages */}
          {message && <p className="text-accent text-sm mb-2">{message}</p>}
          {phase === "transferring" && (
            <p className="text-green-500 text-sm mb-2">Migration is transferring...</p>
          )}
          {error && <p className="text-red-500 text-sm mb-2">{error}</p>}

          {/* Primary CTA */}
          <button
            onClick={handleTransfer}
            disabled={phase !== "idle"}
            className="w-full bg-primary hover:bg-primary-soft disabled:opacity-50 transition font-medium text-white py-2.5 rounded-lg text-sm mt-4"
          >
            {phase === "idle" && "Start Migration Now →"}
            {phase === "transferring" && "Transferring…"}
            {phase === "done" && "Transferred ✅"}
          </button>
        </div>

        {/* Back */}
        <button
          onClick={() => navigate("/")}
          className="flex items-center justify-center gap-2 text-text-muted hover:text-text-secondary mt-6 transition text-sm"
        >
          <ArrowLeft size={16} />
          Back to Home
        </button>
      </div>
    </div>
  );
}